import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'
import App from './App.tsx'
import './index.css'
import './sentry.client'
import './vitals'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ensureFonts } from './lib/fonts-lazy'

// Deferir Service Worker para no tocar el LCP
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    import('./sw/registerServiceWorker')
      .then(m => m.setupServiceWorker())
      .catch(() => {});
  });
}

// Global Calendly event tracking - MOVED TO GTM (index.html)
// Replaced by GTM dataLayer push in index.html to avoid duplicates

function AppRoot() {
  useEffect(() => { 
    // Fonts now loaded in index.html - removed lazy loading to break dependency chain
    // GTM handles analytics - no manual initialization needed
  }, []);
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </HelmetProvider>
  );
}

createRoot(document.getElementById("root")!).render(<AppRoot />);
